import { StandardTextFieldProps, TextField } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import { useCustomTranslations } from '../../../../hooks/useCustomTranslations';
import { RegistrationField } from '../../../../interfaces/interfaces';
import { useSelector } from '../../../../reduxToolkit/typedRedux';
import { RegistrationFormFieldProps } from '../RegistrationFormField';
import validationBuilder from '../../../../static/validations';

interface RegistrationTextFieldInterface extends Omit<RegistrationFormFieldProps, 'register' | 'watch' | 'requiredFieldIds' | 'updateRequiredFieldIds'> {
  isRequired: (field: RegistrationField) => boolean;
  onValueChanged?: (key: string, value: string) => void;
  textFieldSx?: any;
}
const RegistrationTextField = ({
  field: registrationField,
  defaultValue,
  disabled,
  fieldsTextColor,
  fieldsBorderColor,
  variant,
  textFieldSx,
  isRequired,
  showFieldLabel,
  onValueChanged: onChange,
  onBlur,
}: RegistrationTextFieldInterface) => {
  const { t } = useTranslation();
  const { ct } = useCustomTranslations();
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const validations = validationBuilder(t);

  const event = useSelector((state) => state.common.event);
  const label = registrationField.label && showFieldLabel !== false ? ct(registrationField.label, registrationField, 'labelTranslations') : '';

  return (
    <Controller
      control={control}
      name={registrationField._id}
      key={registrationField._id}
      defaultValue={defaultValue ?? ''}
      rules={{
        required: {
          value: isRequired(registrationField),
          message: t('form:fieldrequired'),
        },
        ...(registrationField.isURLField
          ? {
              ...validations('urlWithoutProtocol'),
            }
          : registrationField.validation?.pattern?.value
          ? {
              pattern: {
                value: new RegExp(registrationField.validation.pattern.value),
                message: registrationField.validation.pattern.message || t('pattern-not-matching'),
              },
            }
          : {}),
      }}
      render={({ field }) => {
        return (
          <TextField
            inputRef={field.ref}
            inputProps={{ style: { color: fieldsTextColor || event?.template.mainColor } }}
            variant={variant as StandardTextFieldProps['variant']}
            error={!!errors[registrationField._id]}
            sx={textFieldSx}
            onChange={(e) => {
              if (onChange) onChange(registrationField._id, e.target.value);
              else field.onChange(e.target?.value);
              field.onChange(e.target?.value);
            }}
            onBlur={() => {
              if (onBlur) onBlur(registrationField._id, field.value);
              else field.onBlur();
            }}
            fullWidth
            value={field.value}
            disabled={disabled}
            helperText={errors[registrationField._id]?.message?.toString()}
            label={label}
            id={registrationField.label}
          />
        );
      }}
    />
  );
};
export default RegistrationTextField;
